export const apiGatewayEndpoints = {
  documents: {
    metadata: {
      url: '/document/metadata',
    },
  },
  quickPrompts: {
    getOrgQuickPrompts: {
      url: '/quick-prompts',
    },
    getPromptCardsByCategory: {
      url: '/prompt-card/models/latest',
    },
    getPromptCardsGroups: {
      url: '/prompt-card-groups',
    },
    getPromptCardByVersionId: (id) => ({
      url: `prompt-card/versioned-content/${id}`,
    }),
  },
  editorConfig: {
    getEmailTokensByOrg: {
      url: '/editor-config/email-tokens',
    },
  },
  authoredDocuments: {
    createOrUpdateAuthoredDocument: (id) => ({
      url: `/authored-document/${id}`,
    }),
    getAuthoredDocuments: {
      url: `/authored-document`,
    },
    getAuthoredDocumentById: (id) => ({
      url: `/authored-document/${id}`,
    }),
    downloadAuthoredDocument: (id) => ({
      url: `/authored-document/download/${id}`,
    }),
    duplicateAuthoredDocument: {
      url: `/authored-document/duplicate`,
    },
    authoredDocumentDownloadLink: (id, did, filename) => ({
      url: `/authored-document/download/${id}/${did}/${filename}`,
    }),
    deleteAuthoredDocumentById: (id) => ({
      url: `/authored-document/${id}`,
    }),
  },
  designSystems: {
    templates: {
      url: '/design-system/templates',
    },
    getTemplateById: (id) => ({
      url: `/design-system/templates/${id}`,
    }),
    getDesignSystemById: (id) => ({
      url: `/design-system/${id}`,
    }),
    layouts: {
      url: '/design-system/layouts',
    },
    layoutsThumbs: {
      url: '/thumbnail/layouts',
    },
    getLayoutById: (id) => ({
      url: `/design-system/layout/?id=${id}`,
    }),
    getLayoutsByParentId: (parentId) => ({
      url: `/design-system/layouts/?parentId=${parentId}`,
    }),
  },
  tacticContexts: {
    tacticContextTypes: (regionId) => ({
      url: `/tactic-context-type/by-region/${regionId}`,
    }),
    regions: {
      url: '/region',
    },
    tacticContexts: {
      url: '/tactics/tactic-contexts',
    },
    getTacticContextById: (id) => ({
      url: `/tactic-context/${id}`,
    }),
  },
  collections: {
    reorderDocuments: {
      url: '/collection/documents',
    },
    userCollections: {
      url: '/collections',
    },
    addCollection: {
      url: '/collection',
    },
    updateCollection: {
      url: '/collection',
    },
    removeCollection: {
      url: '/collection',
    },
    addDocumentToCollection: {
      url: '/collection/add',
    },
    removeDocumentFromCollection: {
      url: '/collection/delete',
    },
    createCollectionSharedLink: {
      url: '/collection/shared-link',
    },
    validateSharedLink: (id) => ({
      url: `/collection/shared-link/${id}`,
    }),
    createSharedCollection: {
      url: '/collection/shared',
    },
  },
  glossary: {
    supportedLanguages: {
      url: '/arcane-glossary/supported-languages',
    },
    arcaneGlossaries: {
      url: '/arcane-glossary/glossaries',
    },
    createArcaneGlossary: {
      url: '/arcane-glossary/glossaries',
    },
    updateArcaneGlossary: (id) => ({
      url: `/arcane-glossary/glossaries/${id}`,
    }),
    availableGlossariesByTargetAndSource: (source, target) => ({
      url: `/arcane-glossary/available-glossaries?source=${source}&target=${target}`,
    }),
  },
  files: {
    userFiles: {
      url: 'my-files',
    },
    uploadFile: {
      url: 'file-upload',
    },
  },
  realtime: {
    requestToken: {
      url: '/realtime/requestToken',
      ensureOrganization: true,
    },
  },
  s3Docs: {
    pdfUrl: {
      url: '/document/url',
    },
    pageCovers: {
      url: '/thumbnail/pages',
    },
    sourceUrl: {
      url: '/document/source-url',
    },
    thumbnail: {
      url: '/thumbnail',
    },
    thumbnailImportedImages: {
      url: '/thumbnail/images',
    },
  },
  user: {
    profile: {
      url: '/user/profile',
    },
    userData: (userId) => ({
      url: `/user/${userId}`,
    }),
    changePassword: {
      url: '/user/changePassword',
    },
  },
  logger: {
    putLog: {
      url: '/logger/user-log',
    },
  },
  conversation: {
    userConversations: {
      url: '/conversations',
    },
    conversationById: (id) => ({
      url: `/conversations?conversationId=${id}`,
    }),
  },
  filters: {
    conversationFilters: {
      url: '/filter/dropdowns',
    },
  },
  translation: {
    translateDocument: {
      url: '/translation/translate',
    },
    documentTranslations: {
      url: '/translation/document-translations',
    },
    getAvailableTranslations: {
      url: '/translation/translations',
    },
    getTargetLanguages: {
      url: '/translation/target-languages',
    },
    getSourceLanguages: {
      url: '/translation/source-languages',
    },
    sourceTranslationAvailable: {
      url: '/translation/source-translation-available',
    },
    translateSource: {
      url: '/translation/translate-source',
    },
  },
  platform: {
    platformNotifications: {
      url: '/platform-notifications',
    },
  },
  mediaImages: {
    url: '/fetch_images',
  },
};
